<div class="filter-group">
    <div class="filter-group__main filter-group_row">
        <!--Nicht-ausklappbare Filter-->
        <ng-content select="[filter-main]"></ng-content>
    </div>
    <div class="filter-group__optional filter-group_row" *ngIf="optionalVisible">
        <!--Ausklappbare Filter-->
        <ng-content select="[filter-optional]"></ng-content>
    </div>
</div>

<div class="filter-group__toggle"
     [class.inactive]="optionalDisabled === true"
     (click)="toggleOptional()">
    <span class="d-flex">
        <span ibtnUnboxed *ngIf="!optionalDisabled"
              [class.icon-close]="optionalVisible"
              [class.icon-open]="!optionalVisible"></span>
        <span class="filter-group__toggle_labels">
            <ng-content select="[filter-toggle-label]"></ng-content>
        </span>
    </span>
    <div class="filter-group__toggle_icons">
        <ng-content select="[filter-toggle-icon]"></ng-content>
    </div>
</div>
